module.exports = __webpack_public_path__ + "static/media/mglogo.2be21a5d.svg";